import { prettyDOM } from '@testing-library/dom';
import { cleanup, fireEvent, render, RenderOptions, screen } from '@testing-library/react';
import { act, renderHook } from '@testing-library/react-hooks/dom';
import userEvent from '@testing-library/user-event';
import { ReactNode } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { MemoryRouter } from 'react-router-dom';
import SnackbarProvider from 'src/components/molecules/SnackbarProvider';
import { ThemeProvider } from 'styled-components';

import store from 'src/store';
import theme from '../theme';

type ProvidersProps = { children: ReactNode };
const Providers: React.FC<ProvidersProps> = (props: ProvidersProps) => {
  const { children } = props;
  return (
    <ThemeProvider theme={theme}>
      <ReduxProvider store={store}>
        <SnackbarProvider maxSnack={1} autoHideDuration={2000}>
          <MemoryRouter>{children}</MemoryRouter>
        </SnackbarProvider>
      </ReduxProvider>
    </ThemeProvider>
  );
};

const customRender = (ui: React.ReactElement, options?: Omit<RenderOptions, 'wrapper'>) =>
  render(ui, { wrapper: Providers, ...options });

export {
  customRender as render,
  fireEvent,
  screen,
  prettyDOM,
  cleanup,
  renderHook,
  act,
  userEvent
};
